import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import ItemsListContainerDesktop from './ItemListContainerDesktop';
import ItemsListContainerMobile from './ItemListContainerMobile';
import {
    getTotalExtendedPrice,
    flattenLotSerialArrayOfArrays,
    displayCheckbox,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import {
    getModifiedItemTableData,
    getNewItemObj,
    getUniqueKey,
    invalidProductMsg,
    invalidBundleItemMsg,
    invalidSPSitemMsg,
    productIssueErrMsg,
    emptyBundleMsg,
    invalidUnidRodItemQtyMsg,
    lotNumberReqdMsg,
    serialNumberReqdMsg,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    setAllAccountOwned,
    resetValidatedData,
    resetProgressBarStatus,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { ReportUsageContext } from 'src/pages/reportUsage';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import {
    SET_ITEMS_DURING_PRICING,
    SET_REMOVE_APPLIED_SIGNATURE,
} from 'src/pages/reportUsage/redux/action/types';
import { useTranslation } from 'react-i18next';
import { resetBarcodeDetails } from 'src/common/barCodeScannerRedux/actions/actionCreators';
import useWindowSize from 'src/common/components/getWindowSize';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const ItemsListContext = React.createContext({});

const ItemListView = ({ ...props }) => {
    const winWidth = useWindowSize()[0];    
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        filteredProduct,
        setFilteredProduct,
        selectedProduct,
        addedProduct,
        resetSelectedOrAddedItem,
        setShowHidePricesBtn,
        setToggleHidePricesBtn,
        selectedChildProduct,
        addedChildProduct,
        isFromReportScreen,
        checkNewAddedProduct,
        setPriceOverrideReason,
        setPricingNotes,
    } = props;
    const usageDetails = useContext(ReportUsageContext)?.usageDetails;
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    const { products } = useSelector((state) => ({
        products: state.productsSearchReducer.products,
    }));
    const pricedItems = useSelector(
        (state) => state.reportUsageRootReducer.pricedItems
    );
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );
    const signatureImg = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.base64Image
    );
    const dateOfSignature = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.dateOfSignature
    );
    const itemsWhenSignatureApplied = useSelector(
        (state) => state.reportUsageRootReducer.signatureItemState
    );
    const isProductValidationDone = useSelector(
        (state) => state.reportUsageRootReducer.isProductValidationDone
    );
    const [selectedChildEditItem, setSelectedChildEditItem] = useState(false);
    const [selectedChildIndex, setSelectedChildIndex] = useState();
    const [selectedChildItem, setSelectedChildItem] = useState();
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const [allAccountSelectedModal, setAllAccountSelectedModal] =
        useState(false);
    const [dienFeeDeleteConfirm, setDienFeeDeleteConfirm] = useState(null);

    useEffectWithErrorLogging(() => {
        if (
            pricedItems &&
            pricedItems.length > 0 &&
            filteredProduct.length > 0
        ) {
            const modifiedData = getModifiedItemTableData(
                filteredProduct,
                pricedItems,
                bundleHeadersArr,
                isFromReportScreen,
                usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                myCaseResourceType
            );
            setFilteredProduct(modifiedData);
        }
    }, [pricedItems]);

    const removeAppliedSignature = () => {
        if (
            itemsWhenSignatureApplied?.length > 0 &&
            signatureImg?.length > 0 &&
            dateOfSignature?.length > 0
        ) {
            dispatch({ type: SET_REMOVE_APPLIED_SIGNATURE, payload: true });
        }
    };

    useEffectWithErrorLogging(() => {
        if (selectedProduct && Object.keys(selectedProduct).length > 0) {
            var newProduct = filteredProduct;
            let filteredList = [];
            let filteredProductList = [];
            filteredList = products.filter((item) => {
                return (
                    item.cfn === selectedProduct.value &&
                    item.salesOrg === selectedProduct.salesOrg
                );
            });
            if (filteredList && filteredList.length > 0) {
                filteredList[0].unqId = `${getUniqueKey()} ${
                    selectedProduct.value
                }`;
                filteredList[0].lotSerial = [
                    { Serial: '', used: false, id: getUniqueKey() },
                ];
                if (selectedProduct.isBundle) {
                    filteredList[0].isBundleFromAddItem = true;
                    filteredList[0].children = [];
                    filteredList[0].lotSerial = [
                        {
                            used: '1',
                            isInvalidQtyMsg: null,
                            id: getUniqueKey(),
                        },
                    ];
                    filteredList[0].isBundleExpanded = true;
                }
                filteredList[0].isBundleItem = selectedProduct.isBundle;
                filteredList[0].isInvalidItemMsg = filteredList[0].isSet
                    ? invalidSPSitemMsg()
                    : bundleHeadersArr?.includes(selectedProduct.value) &&
                      selectedProduct.value.toUpperCase().startsWith('M1')
                    ? invalidBundleItemMsg()
                    : null;
                if (
                    usageDetails &&
                    usageDetails?.products &&
                    usageDetails?.products?.find(
                        (item) =>
                            item?.isUnidRodItem &&
                            item?.productCFN?.toLowerCase() ===
                                selectedProduct?.value?.toLowerCase()
                    )
                ) {
                    filteredList[0].isUnidRodItem = true;
                }
                newProduct?.push(filteredList[0]);
            }
            filteredProductList = newProduct.filter((item) => {
                return item !== undefined;
            });

            const newArray = filteredProductList.map((item) => {
                return {
                    ...item,
                    accountOwned: item.accountOwned ? item.accountOwned : false,
                    lotSerial: item.lotSerial
                        ? item.lotSerial
                        : [{ used: false, id: getUniqueKey(), Serial: '' }],
                    extPrice: getTotalExtendedPrice(
                        item.basePrice ? item.basePrice : '',
                        item.lotSerial,
                        'total'
                    ),
                };
            });
            setFilteredProduct(newArray);
            dispatch(setAllAccountOwned(false));
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            removeAppliedSignature();
            dispatch(resetProgressBarStatus());
        }
    }, [selectedProduct]);

    // const [lotFromScanner, setLotFromScanner] = useState(null);
    useEffectWithErrorLogging(() => {
        var newProduct = [...filteredProduct];
        if (addedProduct?.value && Object.keys(addedProduct).length > 0) {
            const existingItem = newProduct?.find(
                (child) =>
                    child.cfn === addedProduct?.value &&
                    child?.lotSerial?.[0]?.Serial ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
            );

            const existingItemIndex = newProduct?.findIndex(
                (child) =>
                    child.cfn === addedProduct?.value &&
                    child?.lotSerial?.[0]?.Serial ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
            );

            if (
                existingItem &&
                existingItemIndex !== -1 &&
                // !selectedProduct.value
                !addedChildProduct?.isFromBundleItemScanner
            ) {
                const existingLotSerial = existingItem.lotSerial[0];
                existingLotSerial.used = parseInt(existingLotSerial.used) + 1;

                newProduct[existingItemIndex] = existingItem;
            } else {
                const newlyAddedItem = getNewItemObj(
                    addedProduct,
                    {},
                    true,
                    bundleHeadersArr,
                    false
                );
                if (
                    usageDetails &&
                    usageDetails.products &&
                    usageDetails.products.find(
                        (item) =>
                            item.isUnidRodItem &&
                            item.productCFN.toLowerCase() ===
                                addedProduct.value.toLowerCase()
                    )
                ) {
                    newlyAddedItem.isUnidRodItem = true;
                }
                // setLotFromScanner(newlyAddedItem?.lotSerial[0]?.Serial);
                newProduct.push(newlyAddedItem);
            }
            setFilteredProduct(newProduct);
            dispatch(setAllAccountOwned(false));
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            removeAppliedSignature();
            dispatch(resetProgressBarStatus());
            resetSelectedOrAddedItem();
            dispatch(resetBarcodeDetails());
        }
    }, [addedProduct]);

    const barcodeData = useSelector(
        (state) => state.BarCodeScannerReducer.barcodeDetails
    );

    useEffectWithErrorLogging(() => {
        if (
            addedChildProduct?.child &&
            Object.keys(addedChildProduct).length > 0
        ) {
            var newProduct = [...filteredProduct];
            let filteredList = [];
            let filteredProductList = [];
            let selectedParentIndex = addedChildProduct.parent.index;
            let selectedParentItem = addedChildProduct.parent.cfn;

            filteredList = newProduct?.filter(
                (item) => item.cfn === selectedParentItem
            );

            if (filteredList) {

                const existingChildItem = filteredList[0]?.children?.find(
                    (child) =>
                        child.cfn === addedChildProduct?.child &&
                        child?.lotSerial?.[0]?.Serial ==
                            addedChildProduct?.lotFromScanner
                                ?.batchOrSerialNumber
                );

                const existingChildItemIndex =
                    filteredList[0]?.children?.findIndex(
                        (child) =>
                            child.cfn === addedChildProduct?.child &&
                            child?.lotSerial?.[0]?.Serial ==
                                addedChildProduct?.lotFromScanner
                                    ?.batchOrSerialNumber
                    );

                if (existingChildItem && existingChildItemIndex !== -1) {
                    const existingLotSerial = existingChildItem.lotSerial[0];
                    existingLotSerial.used =
                        parseInt(existingLotSerial.used) + 1;

                    // Update the newProduct array directly

                    if (addedChildProduct.isBundle) {
                        newlyAddedChildItem.isBundleItem = true;
                        newlyAddedChildItem.isInvalidItemMsg = t(
                            'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                        );
                    }

                    newProduct[selectedParentIndex].isBundleExpanded = true;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children[
                        existingChildItemIndex
                    ] = existingChildItem;
                } else {
                    const newlyAddedChildItem = {
                        cfn: addedChildProduct?.child,
                        dailyRate: '',
                        description: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.description
                            : '',
                        salesOrg: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.salesOrg
                            : '',
                        uom: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.uom
                            : '',
                        accountOwned: false,
                        // lotSerial: lotFromScanner
                        //     ? [
                        //           {
                        //               Serial: lotFromScanner,
                        //               used: 1,
                        //               id: getUniqueKey(),
                        //           },
                        //       ]
                        // lotSerial: barcodeData?.batchOrSerialNumber
                        //     ? [
                        //           {
                        //               Serial: barcodeData?.batchOrSerialNumber,
                        //               used: 1,
                        //               id: getUniqueKey(),
                        //           },
                        //       ]
                        //     : [{ used: false, id: getUniqueKey() }],
                        lotSerial: addedChildProduct?.lotFromScanner
                            ? [
                                  {
                                      Serial: addedChildProduct?.lotFromScanner
                                          ?.batchOrSerialNumber,
                                      used: 1,
                                      id: getUniqueKey(),
                                  },
                              ]
                            : [{ used: false, id: getUniqueKey() }],
                        isBundleFromAddItem: addedChildProduct.isBundle,
                        isSet: addedChildProduct.isSet,
                    };
                    if (addedChildProduct.isBundle) {
                        newlyAddedChildItem.isBundleItem = true;
                        newlyAddedChildItem.isInvalidItemMsg = t(
                            'equity.common.utils.bundleItem'
                        );
                    }

                    if (!newProduct[selectedParentIndex].children)
                        newProduct[selectedParentIndex].children = [];

                    newProduct[selectedParentIndex].isBundleExpanded = true;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children.push(
                        newlyAddedChildItem
                    );
                }
            }

            filteredProductList = newProduct.filter(
                (item) => item !== undefined
            );

            const newArray = filteredProductList.map((item) => {
                return {
                    ...item,
                    accountOwned: item.accountOwned ? item.accountOwned : false,
                };
            });
            setFilteredProduct(newArray);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            removeAppliedSignature();
            dispatch(resetProgressBarStatus());
            dispatch(resetBarcodeDetails());
        }
    }, [addedChildProduct]);

    useEffectWithErrorLogging(() => {
        if (
            selectedChildProduct?.child &&
            Object.keys(selectedChildProduct).length > 0
        ) {
            var newProduct = filteredProduct;
            let filteredList = [];
            let filteredProductList = [];
            let selectedIndex = selectedChildProduct.parent.index;
            let selectedParentItem = selectedChildProduct.parent.cfn;

            filteredList = newProduct?.filter((item) => {
                return item?.cfn == selectedParentItem
                    ? selectedParentItem
                    : '';
            });

            if (filteredList) {
                if (!newProduct[selectedIndex].children)
                    newProduct[selectedIndex].children = [];
                newProduct[selectedIndex].isBundleExpanded = true;

                const filteredChildProducts = products.filter(
                    (item) => item?.cfn === selectedChildProduct?.child
                );

                if (selectedChildProduct.isBundle) {
                    filteredChildProducts[0].isBundleFromAddItem = true;
                    filteredChildProducts[0].isBundleItem = true;
                    filteredChildProducts[0].isInvalidItemMsg = t(
                        'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                    );
                } else if (filteredChildProducts[0].isSet) {
                    filteredChildProducts[0].isInvalidItemMsg = t(
                        'equity.common.utils.setsNotAllowed'
                    );
                } else if (filteredChildProducts[0].salesOrg === 'S030') {
                    filteredChildProducts[0].isInvalidItemMsg =
                        'Tissue items can\'t be added as bundle item.';
                }

                newProduct[selectedIndex].noItemInBundleErr = null;
                newProduct[selectedIndex].children.push({
                    ...filteredChildProducts[0],
                    lotSerial: [{ used: false, id: getUniqueKey() }],
                });
            }

            filteredProductList = newProduct.filter((item) => {
                return item !== undefined;
            });
            const newArray = filteredProductList;
            setFilteredProduct(newArray);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            removeAppliedSignature();
            dispatch(resetProgressBarStatus());
        }
    }, [selectedChildProduct]);

    useEffectWithErrorLogging(() => {
        if (
            filteredProduct?.length > 0 &&
            filteredProduct.some(
                (item) => item.basePrice && item.basePrice.length > 0
            )
        ) {
            setShowHidePricesBtn(true);
            setToggleHidePricesBtn((prevState) => prevState);
        } else {
            setShowHidePricesBtn(false);
            setToggleHidePricesBtn('hideBtn');
        }
    }, [filteredProduct]);

    const onAccountOwnedSeleted = (item, index) => {
        let newAry = [...filteredProduct];
        let isAllSelected = true;
        newAry[index] = { ...item, accountOwned: !item.accountOwned };
        if (newAry.length >= 1) {
            newAry.map((item) => {
                if (!item.accountOwned) {
                    isAllSelected = false;
                }
            });
            setAllAccountSelectedModal(isAllSelected);
            dispatch(setAllAccountOwned(isAllSelected));
        }
        if (
            newAry[index].accountOwned &&
            newAry[index].lotSerial?.length > 0 &&
            newAry[index].lotSerial.some(
                (obj) =>
                    (obj.usedQtyPayment &&
                        Object.keys(obj.usedQtyPayment).length > 0) ||
                    (obj.otherQtyPayment &&
                        Object.keys(obj.otherQtyPayment).length > 0)
            )
        ) {
            newAry[index].lotSerial = newAry[index].lotSerial.map(
                (lotSerialObj) => {
                    const updatedObj = { ...lotSerialObj };
                    delete updatedObj.usedQtyPayment;
                    delete updatedObj.otherQtyPayment;
                    return updatedObj;
                }
            );
        }
        if (!isAllSelected) {
            setFilteredProduct(newAry);
        }
        removeAppliedSignature();
    };

    const onIsSerialUnknown = (item, index, value, lotItemIdx, lotItem) => {
        let newAry = [...filteredProduct];
        let islotSerialUnknownSelection = value;

        newAry[index] = {
            ...item,
            
             lotSerial: item?.lotSerial?.map((lot, idx) =>
                 idx === lotItemIdx
                     ? {
                           ...lot,
                           Serial:
                               islotSerialUnknownSelection !== undefined
                                   ? null
                                   : lot.Serial,
                           lotSerialUnknown: islotSerialUnknownSelection,
                           isInvalidLotSerialMsg:
                               islotSerialUnknownSelection !== undefined
                                   ? null
                                   : lot.isInvalidLotSerialMsg,
                       }
                     : lot
             ),
              
         };

        setFilteredProduct(newAry);
    };
    const deleteAll = () => {
        setFilteredProduct([]);
        resetSelectedOrAddedItem();
        dispatch(resetValidatedData());
        setPriceOverrideReason('');
        setPricingNotes('');
        setShowHidePricesBtn(false);
        setToggleHidePricesBtn('hideBtn');
        dispatch(resetProgressBarStatus());
    };

    const deleteItem = (id, itemIndex, lotSerialItemIdx, bundleIndex) => {
        const sourceList =
            bundleIndex != undefined
                ? filteredProduct?.[bundleIndex]?.children
                : filteredProduct;
        const targetItem = sourceList?.[itemIndex];

                const dienFeeTypeItemNumbers =
                        usageDetails?.dienFeeTypeItemNumbers;
                const dienFeeCodes = Array.isArray(dienFeeTypeItemNumbers)
                        ? dienFeeTypeItemNumbers.filter(Boolean)
                        : typeof dienFeeTypeItemNumbers === 'string' &&
                            dienFeeTypeItemNumbers.length > 0
                        ? dienFeeTypeItemNumbers
                                    .split(',')
                                    .map((code) => code.trim())
                                    .filter(Boolean)
            : [];
        const targetCfn = targetItem?.cfn || targetItem?.productCFN;
        const isDienFee =
            targetItem?.isDienFeeItem ||
            (dienFeeCodes.length > 0 &&
                targetCfn &&
                dienFeeCodes.includes(targetCfn));

        if (isDienFee) {
            setDienFeeDeleteConfirm({
                id,
                itemIndex,
                lotSerialItemIdx,
                bundleIndex,
                cfn: targetCfn,
            });
            return;
        }

        performDeleteItem(id, itemIndex, lotSerialItemIdx, bundleIndex);
    };

    const performDeleteItem = (id, itemIndex, lotSerialItemIdx, bundleIndex) => {
        const updatedList =
            bundleIndex != undefined
                ? [...filteredProduct][bundleIndex].children
                : [...filteredProduct];

        if (
            itemIndex >= 0 &&
            updatedList[itemIndex] &&
            itemsToBePriced?.length > 0
        ) {
            dispatch({
                type: SET_ITEMS_DURING_PRICING,
                payload: itemsToBePriced.filter(
                    (x) => x !== updatedList[itemIndex].cfn
                ),
            });
        }

        updatedList[itemIndex].lotSerial = updatedList[
            itemIndex
        ].lotSerial.filter((item) => item.id !== id);

        if (bundleIndex === undefined) {
            updatedList[itemIndex].extPrice = getTotalExtendedPrice(
                updatedList[itemIndex].basePrice,
                updatedList[itemIndex].lotSerial,
                'total'
            );
        }

        if (updatedList[itemIndex].lotSerial.length === 0) {
            updatedList.splice(itemIndex, 1);
        }

        if (
            updatedList.length > 0 &&
            updatedList.every((item) => item.accountOwned)
        ) {
            setAllAccountSelectedModal(true);
            updatedList[updatedList.length - 1].accountOwned = false;
        }

        if (
            !updatedList.some(
                (item) =>
                    item.adjustedOtherQtyPrice || item.adjustedUsedQtyPrice
            )
        ) {
            setPriceOverrideReason('');
            setPricingNotes('');
        }

        if (bundleIndex != undefined) {
            const temp = [...filteredProduct];
            temp[bundleIndex].children = updatedList;
            if (temp[bundleIndex].basePrice && updatedList?.length === 0) {
                temp[bundleIndex].noItemInBundleErr = emptyBundleMsg();
            }
            setFilteredProduct(temp);
        } else {
            setFilteredProduct(updatedList);
        }
        removeAppliedSignature();
    };

    const confirmDienFeeDelete = () => {
        if (dienFeeDeleteConfirm) {
            const { id, itemIndex, lotSerialItemIdx, bundleIndex } =
                dienFeeDeleteConfirm;
            performDeleteItem(id, itemIndex, lotSerialItemIdx, bundleIndex);
        }
        setDienFeeDeleteConfirm(null);
    };

    const cancelDienFeeDelete = () => setDienFeeDeleteConfirm(null);

    const editItem = (item, index, bundleIndex) => {
        const newAry = [...filteredProduct];

        if (bundleIndex != undefined) {
            newAry[bundleIndex].children[index] = {
                ...item,
                isEditable: true,
            };
        } else {
            newAry[index] = {
                ...item,
                isEditable: true,
            };
        }

        setFilteredProduct(newAry);
    };

    const editChildItem = (item, childIndex) => {
        setSelectedChildEditItem(true);
        setSelectedChildItem(item);
        setSelectedChildIndex(childIndex);
    };

    const addSerialNumber = (item, index, bundleIndex) => {
        let newAry = [...filteredProduct];
        if (bundleIndex != undefined) {
            newAry[bundleIndex].children[index].lotSerial.push({
                id: getUniqueKey(),
            });
            setFilteredProduct(newAry);
        } else {
            newAry[index].lotSerial.push({ id: getUniqueKey() });
            setFilteredProduct(newAry);
        }
    };

    const editedItemList = (e, item, idx, bundleIndex) => {
        const newAry =
            bundleIndex != undefined
                ? [...filteredProduct][bundleIndex].children
                : [...filteredProduct];

        const newValue = e.target.value.trim();
        if (
            newAry[idx].isInvalidItemMsg === invalidProductMsg() &&
            newAry[idx].cfn.toUpperCase() === newValue.toUpperCase()
        ) {
            return;
        } else {
            if (newAry[idx].cfn.toUpperCase() !== newValue.toUpperCase()) {
                if (
                    itemsToBePriced &&
                    itemsToBePriced.length > 0 &&
                    itemsToBePriced.includes(newAry[idx].cfn)
                ) {
                    dispatch({
                        type: SET_ITEMS_DURING_PRICING,
                        payload: itemsToBePriced.filter(
                            (x) => x !== newAry[idx].cfn
                        ),
                    });
                }
                newAry[idx] = getNewItemObj(
                    e.target,
                    newAry[idx],
                    false,
                    bundleHeadersArr,
                    bundleIndex >= 0
                );
                removeAppliedSignature();
                dispatch({
                    type: 'SET_ITEMS_PRICING_DONE_FLAG',
                    payload: false,
                });
                dispatch(resetProgressBarStatus());
            } else {
                newAry[idx] = {
                    ...item,
                    isInvalidItemMsg:
                        newAry[idx].isInvalidItemMsg === invalidProductMsg()
                            ? null
                            : newAry[idx].isInvalidItemMsg,
                    cfn: newValue,
                    isEditable: false,
                };
            }
            if (bundleIndex != undefined) {
                let temp = [...filteredProduct];
                temp[bundleIndex].children = newAry;
                setFilteredProduct(temp);
            } else {
                setFilteredProduct(newAry);
            }
        }
    };

    const editedChildItemList = (e, item, parentIndex) => {
        let newAry = [...filteredProduct];
        if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 9) {
            newAry[parentIndex].children[selectedChildIndex] = {
                ...item,
                cfn: e.target.value,
            };
            setFilteredProduct(newAry);
            setSelectedChildEditItem(false);
        }
    };

    const lotSerialQtyInputChangeHandler = (
        e,
        item,
        index,
        i,
        indexes,
        checkedQty,
        bundleIndex
    ) => {
        var lotSerialValue = [];
        var newArray =
            bundleIndex != undefined
                ? [...filteredProduct][bundleIndex].children
                : [...filteredProduct];
        const previousObj = newArray[index].lotSerial[indexes];
        let SerialValue = {};

        const isUnidBatchPresent = Object.prototype.hasOwnProperty.call(
            e,
            'batches'
        );

        if (
            item.isInvalidUnidItemQuantity &&
            isUnidBatchPresent &&
            previousObj.Serial !== e.batches
        ) {
            newArray[index].lotSerial[indexes].isInvalidQtyMsg =
                newArray[index].lotSerial[indexes].selectedBatchValue !==
                e.batches
                    ? null
                    : invalidUnidRodItemQtyMsg;
        }

        if (
            (item.salesOrg !== 'S030' ||
                item.salesOrg === '' ||
                !item.salesOrg) &&
            !displayCheckbox(item)
        ) {
            const isQuantityField =
                !isUnidBatchPresent &&
                (e.target.name?.toLowerCase() ===
                    t('reportUsage.itemList.used').toLowerCase() ||
                    e.target.name?.toLowerCase() ===
                        t('reportUsage.itemList.other').toLowerCase());

            let values = {};
            values = {
                ...previousObj,
                [isUnidBatchPresent
                    ? 'Serial'
                    : e.target.name.toLowerCase() ===
                      t('reportUsage.itemList.used').toLowerCase()
                    ? 'used'
                    : e.target.name.toLowerCase() ===
                      t('reportUsage.itemList.other').toLowerCase()
                    ? 'other'
                    : e.target.name]: isUnidBatchPresent
                    ? e.batches || ''
                    : isQuantityField
                    ? isNaN(parseInt(e.target.value))
                        ? ''
                        : parseInt(e.target.value)
                    : e.target.value.trim(),
            };
            newArray[index].lotSerial.splice(indexes, 1, values);

            if (
                !isUnidBatchPresent &&
                isQuantityField &&
                values.isInvalidQtyMsg !==
                    t('reportUsage.itemTableErrorMessages.Bundle')
            ) {
                if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    (e.target.value === '0' || e.target.value === '00')
                ) {
                    values.isInvalidQtyMsg =
                        bundleIndex >= 0 || item.isBundleItem
                            ? t(
                                  'productValidationMessages.mustEnterUsedQuantity'
                              )
                            : t(
                                  'productValidationMessages.mustEnterUsedOrOtherQuantity'
                              );
                } else if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    +e.target.value > 1 &&
                    item?.cfn?.startsWith('S33')
                ) {
                    values.isInvalidQtyMsg = t(
                        'productValidationMessages.feeQtyCanOnlyOne'
                    );
                } else if (
                    item.isInvalidUnidItemQuantity &&
                    item.batchQtyObjArr?.length > 0
                ) {
                    const batchQtyObj = item.batchQtyObjArr.filter(
                        (b) => b.batch === values.Serial && b.deliveredQty
                    );
                    if (batchQtyObj && batchQtyObj[0]) {
                        const unidDeliveredQty = batchQtyObj[0].deliveredQty;
                        const usedQty =
                            isNaN(values.used) || !values.used
                                ? 0
                                : parseInt(values.used);
                        const otherQty =
                            isNaN(values.other) || !values.other
                                ? 0
                                : parseInt(values.other);
                        const totalUnidQty = usedQty + otherQty;

                        values.isInvalidQtyMsg =
                            totalUnidQty &&
                            unidDeliveredQty &&
                            totalUnidQty > parseInt(unidDeliveredQty)
                                ? invalidUnidRodItemQtyMsg
                                : null;
                    } else {
                        values.isInvalidQtyMsg = null;
                    }
                } else {
                    values.isInvalidQtyMsg = null;
                }
                removeAppliedSignature();
            }
        }

        if (
            !isUnidBatchPresent &&
            (item.salesOrg === 'S030' || displayCheckbox(item))
        ) {
            const values = {
                ...previousObj,
                [e.target.name]: e.target?.value?.trim(),
            };
            lotSerialValue.push(values);
            SerialValue = Object.assign({}, ...lotSerialValue);
            newArray[index].lotSerial[indexes] = {
                ...i,
                used: i.used !== undefined ? i.used : false,
                isInvalidLotSerialMsg:i?.Serial!==SerialValue?.Serial?null:i?.isInvalidLotSerialMsg,
                Serial: Object.keys(SerialValue).length
                    ? SerialValue.Serial
                    : '',
            };
            if (checkedQty === 'usedChecked') {
                newArray[index].lotSerial[indexes] = {
                    ...i,
                    used: !i.used,
                    isInvalidQtyMsg: !i.used === true ? null : false,
                    other: !i.used === true ? false : i.other,
                };
                removeAppliedSignature();
            }
            if (checkedQty === 'otherChecked') {
                newArray[index].lotSerial[indexes] = {
                    ...i,
                    other: !i.other,
                    isInvalidQtyMsg: !i.other === true ? null : false,
                    used: !i.other === true ? false : i.used,
                };
                removeAppliedSignature();
            }
        }

        if (
            !isUnidBatchPresent &&
            e.target.name?.toLowerCase() === 'serial' &&
            (newArray[index].isLotSerialReqd ||
                newArray[index].isSerialRequired) &&
            !newArray[index].isInvalidItemMsg
        ) {
            if (e.target.value?.trim()?.length > 0) {
                const itemLotSerialArr = flattenLotSerialArrayOfArrays(
                    'serialIssued',
                    newArray,
                    newArray[index].cfn
                );
                const lotSerialArrExceptFocused = itemLotSerialArr.filter(
                    (obj) =>
                        obj.id !== newArray[index].lotSerial[indexes].id &&
                        obj.Serial === newArray[index].lotSerial[indexes].Serial
                );
                newArray[index].lotSerial[indexes].isInvalidLotSerialMsg =
                    !newArray[index].isLot &&
                    lotSerialArrExceptFocused
                        .map((x) => x.Serial)
                        .includes(e.target.value)
                        ? productIssueErrMsg
                        : false;

                if (
                    lotSerialArrExceptFocused.every(
                        (x) => x.isInvalidLotSerialMsg === productIssueErrMsg
                    ) &&
                    newArray[index].lotSerial[indexes].isInvalidLotSerialMsg ===
                        productIssueErrMsg
                ) {
                    newArray[index].lotSerial[
                        indexes
                    ].isInvalidLotSerialMsg = false;
                }
            } else {
                newArray[index].lotSerial[indexes].isInvalidLotSerialMsg =
                    isProductValidationDone &&
                    (newArray[index].isLot
                        ? lotNumberReqdMsg()
                        : newArray[index]?.productCFN.startsWith('S33')
                        ? 'VendorCaseId field should not be Empty'
                        : serialNumberReqdMsg());
                newArray[index].lotSerial[indexes].linkedSstref =
                    newArray[index].lotSerial[indexes]?.linkedSstref?.length > 0
                        ? newArray[index]?.lotSerial[indexes]?.Serial?.length >
                          0
                            ? newArray[index].lotSerial[indexes]?.linkedSstref
                            : ''
                        : '';
            }
        }
        if (bundleIndex != undefined) {
            let temp = [...filteredProduct];
            temp[bundleIndex].children = newArray;
            setFilteredProduct(temp);
        } else {
            newArray[index].usedQtyExtPrice = getTotalExtendedPrice(
                newArray[index].basePrice,
                newArray[index].lotSerial,
                'used'
            );
            newArray[index].otherQtyExtPrice = getTotalExtendedPrice(
                newArray[index].basePrice,
                newArray[index].lotSerial,
                'other'
            );
            newArray[index].extPrice = getTotalExtendedPrice(
                newArray[index].basePrice,
                newArray[index].lotSerial,
                'total'
            );
            setFilteredProduct(newArray);
        }
    };

    const bundleExpandCollapseIconClickHandler = (e, item, itemIdx) => {
        const modifiedData = [...filteredProduct];
        if (item.isBundleItem && item.children?.length > 0 && itemIdx >= 0) {
            modifiedData[itemIdx].isBundleExpanded =
                !modifiedData[itemIdx].isBundleExpanded;
            setFilteredProduct(modifiedData);
        }
    };

    return (
        <>
            {allAccountSelectedModal && (
                <WarningModal
                    message={t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.msg'
                    )}
                    onClose={() => setAllAccountSelectedModal(false)}
                    title={t('consignmentBilling.itemList.accountOwned')}
                    mbHeight={'max-content'}
                    mbMarginBottom={'10px'}
                />
            )}
            {dienFeeDeleteConfirm && (
                <CancelAlertPopup
                    id={'reportUsage-itemsList-dienFeeDelete-cancelAlertPopup'}
                    popupTitle={t('reportUsage.common.dienFeeDelete.title')}
                    isDienFeeItem={true}
                    alertMessage={
                        <>
                            {t('reportUsage.common.dienFeeDelete.messagePart1')}
                            <strong>{dienFeeDeleteConfirm.cfn}</strong>
                            {t('reportUsage.common.dienFeeDelete.messagePart2')}
                            <strong>{t('reportUsage.common.dienFeeDelete.yesLabel')}</strong>
                            {t('reportUsage.common.dienFeeDelete.messagePart3')}
                            <strong>{t('reportUsage.common.dienFeeDelete.noLabel')}</strong>
                            {t('reportUsage.common.dienFeeDelete.messagePart4')}
                        </>
                    }
                    btn1Label={t('reportUsage.common.dienFeeDelete.noLabel')}
                    btn2Label={t('reportUsage.common.dienFeeDelete.yesLabel')}
                    btn1ClickHandler={cancelDienFeeDelete}
                    btn2ClickHandler={confirmDienFeeDelete}
                    btnCloseClickHandler={cancelDienFeeDelete}
                    cancelBtn
                />
            )}
            {winWidth > sizes.largportraitDevice ? (
                <ItemsListContainerDesktop
                    filteredProduct={filteredProduct}
                    selectedChildEditItem={selectedChildEditItem}
                    selectedChildItem={selectedChildItem}
                    selectedChildIndex={selectedChildIndex}
                    onAccountOwnedSeleted={onAccountOwnedSeleted}
                    onIsSerialUnknown={onIsSerialUnknown}
                    deleteAll={deleteAll}
                    deleteItem={deleteItem}
                    editItem={editItem}
                    editChildItem={editChildItem}
                    addSerialNumber={addSerialNumber}
                    editedItemList={editedItemList}
                    editedChildItemList={editedChildItemList}
                    lotSerialValueEntered={lotSerialQtyInputChangeHandler}
                    bundleExpandCollapseIconClickHandler={
                        bundleExpandCollapseIconClickHandler
                    }
                    isFromReportScreen={isFromReportScreen}
                    checkNewAddedProduct={checkNewAddedProduct}
                    isLanguageChanged={isLanguageChanged}
                    {...props}
                />                
            ) : (
                <ItemsListContainerMobile
                    filteredProduct={filteredProduct}
                    onAccountOwnedSeleted={onAccountOwnedSeleted}
                    deleteAll={deleteAll}
                    deleteItem={deleteItem}
                    editItem={editItem}
                    addSerialNumber={addSerialNumber}
                    editedItemList={editedItemList}
                    lotSerialValueEntered={lotSerialQtyInputChangeHandler}
                    bundleExpandCollapseIconClickHandler={
                        bundleExpandCollapseIconClickHandler
                    }
                    isFromReportScreen={isFromReportScreen}
                    checkNewAddedProduct={checkNewAddedProduct}
                    onIsSerialUnknown={onIsSerialUnknown}
                    {...props}
                />
            )}
        </>
    );
};

export default ItemListView;
